function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "loginDiamondBottom_svg__a",
  d: "M93.514 107.504l90.35 93.47-93.47 90.35-90.35-93.47zM232.021 73.985l61.855 63.991-63.991 61.855-61.855-63.991zM159.229 0l29.885 30.917-30.917 29.885-29.885-30.917z"
});

function SvgLoginDiamondBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 293.846 291.323"
  }, props), _ref, _ref2);
}

export default SvgLoginDiamondBottom;